import { render, staticRenderFns } from "./Wap.vue?vue&type=template&id=0a69b749&scoped=true&"
import script from "./Wap.vue?vue&type=script&lang=js&"
export * from "./Wap.vue?vue&type=script&lang=js&"
import style0 from "./Wap.vue?vue&type=style&index=0&id=0a69b749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a69b749",
  null
  
)

export default component.exports